import Trip from '../Trip';
import { VehicleType } from '../types';
import SuggestionService from '../SuggestionService';
import type TrainPriceClass from './TrainPriceClass';
import { type AvailableTrain } from '@clients/TrainApi';

export default class Train extends Trip {
    /**
     * Time of train Departure from origin in 'hh:mm' format
     */
    override departureTime: string;

    override stops: number;

    /**
     * Time of train arrival to destination in 'hh:mm' format
     */
    override arrivalTime: string;

    override origin: string;

    override destination: string;

    reservable = true;

    override departureDateTime: Date = new Date(0);

    override arrivalDateTime: Date = new Date(0);

    override vehicleType: VehicleType = VehicleType.Train;

    override originCityName: string;

    override originCode = '';

    override originTerminal = 'ایستگاه راه‌آهن';

    override destinationCityName: string;

    override destinationCode = '';

    override destinationTerminal = 'ایستگاه راه‌آهن';

    override key = '';

    override showCityCodes = false;

    id = 0;
    duration_ = 0;

    override get serviceId(): number {
        return this.id;
    }

    override get destinationHasWarning() {
        return false;
    }

    override serviceNumber = '';

    constructor(
        train: AvailableTrain,
        price: TrainPriceClass,
        logos: string[] = []
    ) {
        super();

        let logoName = `train_${price.ownerID}_${price.wagonID}`;
        if (!logos.includes(`${logoName}.svg`)) {
            logoName = `train_${price.ownerID}`;
        }
        if (!logos.includes(`${logoName}.svg`)) {
            logoName = 'default';
        }

        this.corporationInfo = {
            logoUrl: `/img/trainCorporations/svg/${logoName}.svg`,
            logoFallbackUrl: `/img/trainCorporations/${logoName}.png`,
            title: `${price.OwnerName || train.corporationName}`,
            code: train.corporationID?.toString() ?? '',
            subTitle: train.trainNumber?.toString(),
        };

        this.carrierCode = price.ownerID?.toString() || null;
        this.departureTime = getTime(train.departureTime ?? '');
        this.departureDateTime = dayConfig
            .gregory(train.departureTime)
            .toDate();
        this.stops = 0;
        this.arrivalTime = getTime(train.arrivalTime ?? '');
        this.arrivalDateTime = dayConfig.gregory(train.arrivalTime).toDate();
        this.origin = train.fromName ?? '';
        this.destination = train.toName ?? '';
        this.duration_ =
            this.arrivalDateTime.getTime() - this.departureDateTime.getTime();
        this.vehicleInfo = {
            title: 'قطار',
            code: price.wagonID.toString(),
            type: price.wagonName,
            description: price.isCompartment
                ? `کوپه‌ای ${price.compartmentCapacity} نفره (${price.styledWagonName})`
                : `اتوبوسی (${price.styledWagonName})`,
        };
        this.originCityName = train.fromName ?? '';
        this.destinationCityName = train.toName ?? '';
        this.originCode = train.from?.toString() ?? '';
        this.destinationCode = train.to?.toString() ?? '';
        this.id = train.id ?? 0;
        this.serviceNumber = train.trainNumber?.toString() ?? '';
        this.key = train.id?.toString() ?? '';
        this.suggestionServices =
            price.price?.suggestedServices?.map(
                ss =>
                    new SuggestionService({
                        description: ss.description ?? '',
                        price: ss.price ?? 0,
                        discount: 0,
                        image: ss.images?.[0] ?? '',
                        id: ss.id ?? 0,
                        title: ss.title ?? '',
                        unitTitle: ss.unitTitle ?? '',
                        needDescription: !!ss.needDescription,
                    })
            ) || [];
    }
}
